<template>
  <section class="experiencia">
    <h2><span>Vive la</span>Experiencia</h2>
    <div class="galeria">
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_01.jpg" alt="Galeria 01">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_02.jpg" alt="Galeria 02">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_03.jpg" alt="Galeria 03">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_04.jpg" alt="Galeria 04">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_05.jpg" alt="Galeria 05">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_06.jpg" alt="Galeria 06">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_07.jpg" alt="Galeria 07">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_08.jpg" alt="Galeria 08">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_09.jpg" alt="Galeria 09">
      </div>
      <div class="imagen">
          <img src="../../assets/img/galeria/galeria_10.jpg" alt="Galeria 10">
      </div>
    </div>
  </section>
</template>

<style scoped>
.galeria {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
@media (min-width: 1024px) {
  .galeria {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
}
.galeria .imagen img {
  height: 30rem;
  width: 30rem;
  object-fit: cover;
}
@media (min-width: 1024px) {
  .galeria .imagen:nth-child(1) {
    grid-row: 1/3;
  }
  .galeria .imagen:nth-child(1) img {
    height: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(2) {
    grid-column: 2/4;
  }
  .galeria .imagen:nth-child(2) img {
    width: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(4) {
    grid-row: 2/4;
  }
  .galeria .imagen:nth-child(4) img {
    height: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(5) {
    grid-column: 3/5;
  }
  .galeria .imagen:nth-child(5) img {
    width: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(6) {
    grid-column: 3/5;
  }
  .galeria .imagen:nth-child(6) img {
    width: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(7) {
    grid-column: 1/2;
    grid-row: 3/5;
  }
  .galeria .imagen:nth-child(7) img {
    height: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(8) {
    grid-column: 2/5;
  }
  .galeria .imagen:nth-child(8) img {
    width: 94rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(9) {
    grid-column: 1/3;
  }
  .galeria .imagen:nth-child(9) img {
    width: 62rem;
    object-position: center;
  }
  .galeria .imagen:nth-child(10) {
    grid-column: 3/5;
  }
  .galeria .imagen:nth-child(10) img {
    width: 62rem;
    object-position: center;
  }
}
</style>